import React from "react";

import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { Select } from "../../components/Select";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import styles from "@styles/integrations.module.scss"
import { Context } from "pages/Integrations";

export default class TwilioDrawer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loadingPage: true,
			loading: false,
			sid: null,
			auth_token: null,
			service: null
		};
	}

	componentDidMount() {
		this.loadConfigs();
	}

	async loadConfigs() {
		const environment_id = await EnvironmentStorage.getEnvironmentHoldingId();

		const external_credentials = await EnvironmentsAPI.getConfigurationsByAlias(
			environment_id,
			"external_credentials"
		);
		const twilio_configs = external_credentials.twilio || {};

		if (Object.keys(twilio_configs).length > 0) {
			this.setState({
				sid: twilio_configs.sid,
				auth_token: twilio_configs.auth_token,
				service: twilio_configs.service
			});
		}

		this.setState({
			loadingPage: false,
		});
	}

	async onSave() {
		try {
			const { onSave } = this.props;
			const { sid, auth_token, service } = this.state;

			this.setState({ loading: true });

			const environment_id = await EnvironmentStorage.getEnvironmentHoldingId();

			const external_credentials = await EnvironmentsAPI.getConfigurationsByAlias(
				environment_id,
				"external_credentials"
			);

			const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
				environment_id,
				"external_credentials",
				{
					...external_credentials,
					twilio: {
						sid,
						auth_token,
						service
					},
				}
			);

			this.setState({ loading: false });

			if (updateResponse.getErrors([]).length === 0) {
				onSave && onSave();
			} else {
				alert({
					text: `Não foi possível alterar a configuração: ${updateResponse.getErrors()[0]}`,
				});
			}
		} catch (e) {
			this.setState({ loading: false });
		}
	}

	render() {
		const { loading, loadingPage, sid, auth_token, service } = this.state;
		const { visible, onClose } = this.props;

		const isValid = sid && auth_token && service;

		return (
			<Drawer
				visible={visible}
				onClose={onClose}
				closeInFade
				title={"Twilio"}
				footer={
					<Button
						design="primary"
						className="w-100"
						onClick={() => this.onSave()}
						loading={loading}
						disabled={loading || !isValid}
					>
						Salvar alterações
					</Button>
				}
			>
				{loadingPage ? (
					<div className="d-flex justify-center align-center h-100">
						<Loading fullScreen />
					</div>
				) : (
					<div className={styles.scrollContainer}>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Account SID"
							value={sid}
							onChange={(e) => this.setState({ sid: e.target.value })}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Auth Token"
							value={auth_token}
							onChange={(e) => this.setState({ auth_token: e.target.value })}
						/>
						<Input
							design="two"
							className="mb-20"
							floatLabel="Service SID"
							value={service}
							onChange={(e) => this.setState({ service: e.target.value })}
						/>
					</div>
				)}
			</Drawer>
		);
	}
}
